module.exports = __webpack_public_path__ + "static/media/business-dollar-emoji-emoticon-finance-money-svgrepo-com.9cb4864d.svg";